import styled from 'styled-components';

export const AnimationContainer = styled.div`
  height: 10rem;
`;
export const Animation = styled.div``;
